import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryStockBalanceSummary } from '@/renderer/services/inventoryStockBalanceService';
import type { InventoryStockBalanceFilterParams } from '@/renderer/types/inventory';

export function useInventoryStockBalanceSummary(
  companyId: number | null | undefined,
  outletId: string | null | undefined,
  search: string,
  stockLocationId: InventoryStockBalanceFilterParams['stockLocationId'],
  inventoryItemIds?: InventoryStockBalanceFilterParams['inventoryItemIds'],
) {
  const normalizedInventoryItemIds = inventoryItemIds ?? [];

  return useQuery({
    queryKey: queryKeys.inventory.stockBalanceSummary(
      companyId ?? 0,
      outletId ?? '',
      search,
      stockLocationId ?? 'all',
      normalizedInventoryItemIds,
    ),
    queryFn: async () => {
      const result = await fetchInventoryStockBalanceSummary(
        companyId ?? 0,
        outletId ?? '',
        search,
        stockLocationId,
        normalizedInventoryItemIds,
      );
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch inventory stock balance summary',
        );
      }

      return result.data;
    },
    enabled: !!companyId && !!outletId,
  });
}
